import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { handleOAuthCallback, isUserAuthenticated, getUser } from "../../services/AuthService"

function OAuthCallback({setIsAuthenticated}) {
    // rerendering the components does not change isProcessed, but remounting the component does change.
    const isProcessed = useRef(false);
    const history = useHistory();

    useEffect(() => {
        async function processOAuthResponse() {
            // this is needed, because React.StrictMode makes component to rerender
            // second time the auth code that is in req.url here is invalid,
            // so we want it to execute one time only.
            if (isProcessed.current) {
                return;
            }

            isProcessed.current = true;

            try {
                const currentUrl = window.location.href;
                await handleOAuthCallback(currentUrl);
                const isAuthen = await isUserAuthenticated();
                const user = await getUser();
                setIsAuthenticated({
                    isAuthenticated: isAuthen,
                    principal: user,
                  });
                history.push("/"); // Redirect after login
            } catch (error) {
                console.error("Error processing OAuth callback:", error);
            }
        }
        processOAuthResponse();
    }, [])
}

export default OAuthCallback;